import Vue from 'vue'
import FireworkArtwork from './FireworkArtwork'
import Firework from './Firework'
import FireworkStar from './FireworkStar'
import FireworkFire from './FireworkFire'

Vue.use({
  install() {
    Vue.prototype.$artworkFirework = FireworkArtwork
  }
})

export { FireworkArtwork, Firework, FireworkStar, FireworkFire }
